import React from "react";

import styles from "./index.module.scss";

const CompositionsCard = () => (
  <div className={styles.video}>
    <video
      className={styles.video__card}
      width="600"
      autoPlay
      controls
      muted
      loop
    >
      <source
        src="/videos/video.mp4"
        type="video/mp4"
        className={styles.video__source}
      />
      Ваш браузер не поддерживает видео.
    </video>
  </div>
);

export default CompositionsCard;
